module.exports = __webpack_public_path__ + "media/images/flags/4x3/isr-6701e0f046e27d38cb2979e7efa64522.svg";